import { api } from '../../lib/api.ts'
import { proto, type TaskInput } from '../../prototype/state/store.ts'
import type { TaskRecord } from './api.ts'

const creationRequests = new Map<string, string>()

const versionOf = (id: string) => {
  const task = proto.state.tasks.find((candidate) => candidate.id === id)
  if (!task) throw new Error('Завдання не знайдено. Оновіть дані.')
  return task.version
}

const transition = (id: string, action: 'complete' | 'reopen' | 'cancel') =>
  api<TaskRecord>(`/tasks/${encodeURIComponent(id)}/${action}`, {
    method: 'POST',
    body: JSON.stringify({ version: versionOf(id) }),
  })

export const taskActions = {
  addTask: async (input: TaskInput) => {
    const key = JSON.stringify(input)
    const requestId = creationRequests.get(key) ?? crypto.randomUUID()
    creationRequests.set(key, requestId)
    const task = await api<TaskRecord>('/tasks', {
      method: 'POST',
      body: JSON.stringify({ ...input, requestId }),
    })
    creationRequests.delete(key)
    return task.id
  },
  updateTask: (id: string, patch: Partial<TaskInput>, version = versionOf(id)) =>
    api<TaskRecord>(`/tasks/${encodeURIComponent(id)}`, {
      method: 'PATCH',
      body: JSON.stringify({ ...patch, version }),
    }),
  completeTask: (id: string) => transition(id, 'complete'),
  reopenTask: (id: string) => transition(id, 'reopen'),
  cancelTask: (id: string) => transition(id, 'cancel'),
  dismiss: (id: string) => api('/tasks/dismiss', { method: 'POST', body: JSON.stringify({ id }) }),
}
